import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicationInfosResponse } from '../types'

export const useDeclineApplication = ({ orderId }: { orderId?: number }) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      applicationId
    }: {
      applicationId: number
      skipInvalidation?: boolean
    }) => {
      return await fetchApiWithToken<ApplicationInfosResponse>({
        method: 'post',
        url: `/v1/applications/${applicationId}/decline`,
        data: {}
      })
    },
    onSuccess: (data, variables) => {
      if (variables.skipInvalidation) {
        return
      }

      queryClient.setQueryData(['applications', variables.applicationId], data)

      queryClient.invalidateQueries({
        queryKey: ['applications']
      })

      if (orderId) {
        queryClient.invalidateQueries({
          queryKey: ['order', orderId]
        })
      }

      queryClient.invalidateQueries({
        queryKey: ['orders']
      })
    }
  })
}
